(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('ConsInfAccountDialogController', ConsInfAccountDialogController);

    ConsInfAccountDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'ConsInfAccount', 'ConsInfUser'];

    function ConsInfAccountDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, ConsInfAccount, ConsInfUser) {
        var vm = this;

        vm.consInfAccount = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.consinfusers = ConsInfUser.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.consInfAccount.id !== null) {
                ConsInfAccount.update(vm.consInfAccount, onSaveSuccess, onSaveError);
            } else {
                ConsInfAccount.save(vm.consInfAccount, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consinfApp:consInfAccountUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creationDate = false;
        vm.datePickerOpenStatus.renewalDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
